import isEmpty from "lodash/isEmpty";

import find from "lodash/find";

import { fontFamilies } from "@/theme/font-families";
import type { HomePageRevision, Theme } from "@/types";

import { getBrandColorShadeFromHex } from "@/lib";

export const getEhqTheme = (
  theme: Partial<Theme>,
  homePageRevision: Partial<HomePageRevision>
) => {
  if (isEmpty(homePageRevision) || isEmpty(theme)) return {};

  const bodyFontFamily =
    find(fontFamilies, (f) => f.key === theme.contentFont) || fontFamilies[0];
  const headingFontFamily =
    find(fontFamilies, (f) => f.key === theme.titleFont) || fontFamilies[0];

  const fonts = { bodyFontFamily, headingFontFamily };

  const ehqTheme = {
    colors: {
      brand: {
        "50": getBrandColorShadeFromHex(`${theme.brandColor}`, 0.9),
        "100": getBrandColorShadeFromHex(`${theme.brandColor}`, 0.8),
        "200": getBrandColorShadeFromHex(`${theme.brandColor}`, 0.6),
        "300": getBrandColorShadeFromHex(`${theme.brandColor}`, 0.4),
        "400": getBrandColorShadeFromHex(`${theme.brandColor}`, 0.2),
        "500": theme.brandColor,
        "600": getBrandColorShadeFromHex(`${theme.brandColor}`, 0.4, "dark"),
        "700": getBrandColorShadeFromHex(`${theme.brandColor}`, 0.5, "dark"),
        "800": getBrandColorShadeFromHex(`${theme.brandColor}`, 0.6, "dark"),
        "900": getBrandColorShadeFromHex(`${theme.brandColor}`, 0.8, "dark")
      }
    },
    radii: {
      site: homePageRevision.sections.meta.borderRadius
    },
    shadows: {
      site: homePageRevision.sections.meta.boxShadow
    },
    fonts: {
      body: `${bodyFontFamily.name}, Helvetica, Arial, sans-serif`,
      heading: `${headingFontFamily.name}, Helvetica, Arial, sans-serif`
    },
    fontWeights: {
      body: 400,
      heading: 700
    },
    fontSizes: {
      body: `${homePageRevision.sections.meta.baseFontSize}em`,
      heading: `${homePageRevision.sections.meta.headingFontSize}em`,
      sectionTitle: `${homePageRevision.sections.meta.sectionTitleFontSize}em`
    }
  };

  return { ehqTheme, fonts };
};
